import React from 'react'
import PropTypes from 'prop-types'

function PageHeader({ image, title, subtitle = '' }) {
  const headerStyles = { backgroundImage: `url(${image})` }

  return (
    <header className="event-page__header" style={headerStyles}>
      <div className="header-overlay">
        <h1 className="heading-20 text-white text-bold u-mt0 u-mb0 event-page__title">{title}</h1>
        {subtitle && (
          <p className="heading-16 text-white u-text-center event-page__subtitle">{subtitle}</p>
        )}
      </div>
    </header>
  )
}

PageHeader.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

export default PageHeader
